import Vue from 'vue';
import { http } from '../../axios';
import RevolutCheckout from '@revolut/checkout';

function catchError(title = 'Something went wrong', message) {
  return () => {
    Vue.prototype.$vModal.open('warning', { title, message })
  };
}

export default {
  namespaced: true,
  actions: {
    async getTopUpToken(_, { price }) {
      const { data } = await http.post('/api/cabinet/employer/wallet/topup-balance', { sum: price })
        .catch(catchError(undefined, 'Failed to select price'));

      return data?.data.public_id;
    },
    async payWithPopup({ rootState }, { paymentPublicId, mode }) {
      const instance = await RevolutCheckout(paymentPublicId, mode);

      instance.payWithPopup({
        email: rootState.user.profile.email,
        locale: rootState.currentLocale,
        onError: () => {
          this.$vModal.open('warning', {
            message: this.$AccountSubscription('revolut_topup_payment_error'),
          });
        },
      });
    },
  },
};
